<template>
  <div class="left-content">
    <div class="left-top">
      <div class="header">
        <div class="title" @click="pushRouter('zfStatistics/zonglan')">业务统计</div>
        <div class="tags">
          <div>
            <el-radio-group style=" display: flex; flex-wrap: nowrap;padding-right: 10px;" @input="changeDateType"
              v-model="dateType" fill="#1B4498" size="mini">
              <el-radio-button label="year">年</el-radio-button>
              <el-radio-button label="month">月</el-radio-button>
            </el-radio-group>
          </div>
          <div>
            <el-date-picker v-if="dateType == 'month'" :clearable="false" prefix-icon="" v-model="dateRange"
              type="monthrange" range-separator="-" value-format="yyyy-MM" size="mini" :picker-options="pickerOptions"
              style="width: 200px;" @change="getStatistics()">
            </el-date-picker>
            <div v-else style="display: flex;">
              <el-date-picker style="width: 100px;padding-right: 5px;" :clearable="false" size="mini"
                v-model="searchParams.startYear" :picker-options="startDatePicker" value-format="yyyy" type="year"
                @change="getStatistics()">
              </el-date-picker>
              -
              <el-date-picker style="width: 100px;padding-left: 5px;" :clearable="false" size="mini"
                v-model="searchParams.endYear" :picker-options="endDatePicker" value-format="yyyy" type="year"
                @change="getStatistics()">
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-main" id="dw-chart"></div>
    </div>
    <div class="left-bottom">
      <div class="header">
        <div class="title" @click="pushRouter('zfWarning/charts')">预警/警报</div>
        <div class="tags">
          <el-radio-group @input="changeLastDay" v-model="lastDay" fill="#1B4498" size="mini">
            <el-radio-button label="0">今日</el-radio-button>
            <el-radio-button label="30">近30日</el-radio-button>
            <el-radio-button label="90">近90日</el-radio-button>
          </el-radio-group>

        </div>
      </div>
      <div class="warning-table">
        <ul class="list-title">
          <li>
            <p class="warnings-table-no" title="序号">序号</p>
            <p class="warnings-table-name" title="企业名称">企业名称</p>
            <p class="warnings-table-content" title="提醒内容">提醒内容</p>
            <p class="warnings-table-status" title="状态">状态</p>
          </li>
        </ul>
        <vue-seamless-scroll :data="warningsData" class="seamless-warp" :class-option="optionSetting">
          <ul class="scoll-main">
            <li class="main-list" v-for="(item, index) in warningsData" :key="index">
              <p class="warnings-table-no" :title="item.index">{{ index + 1 }}</p>
              <p class="warnings-table-name" :title="item.companyName">{{ item.companyName }}</p>
              <p class="warnings-table-content" :title="item.warningContent">{{ item.warningContent }}</p>
              <p class="warnings-table-status" :title="item.status">{{ item.status }}</p>
            </li>
          </ul>
        </vue-seamless-scroll>

      </div>
    </div>
  </div>
</template>

<script>

import * as echarts from "echarts";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {

  components: { vueSeamlessScroll },
  data() {
    return {
      dateRange: [],
      searchParams: {
        startYear: null,
        endYear: null,
      },
      pickerMinDate: null,
      pickerMaxDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {

          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 30 * 24 * 3600 * 1000 * 6
            let maxTime = this.pickerMinDate + day1
            let minTime = this.pickerMinDate - day1
            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now()
          } else {
            return time.getTime() > Date.now()
          }
        },

      },
      startDatePicker: {
        disabledDate: time => {
          const thisYear = new Date().getFullYear();
          if (this.searchParams.endYear) {
            return time.getFullYear() >= this.searchParams.endYear || time.getFullYear() < this.searchParams.endYear - 6 || time.getFullYear() > thisYear
          } else {
            return time.getFullYear() > thisYear
          }
        }
      },
      endDatePicker: {
        disabledDate: time => {
          const thisYear = new Date().getFullYear();
          if (this.searchParams.startYear) {
            return time.getFullYear() <= this.searchParams.startYear || time.getFullYear() > parseInt(this.searchParams.startYear) + 6 || time.getFullYear() > thisYear
          } else {
            return time.getFullYear() > thisYear
          }
        }
      },
      dateType: 'year',
      lastDay: '90',
      warningsData: [],
      statisticsData: [],
    }
  },
  computed: {


    optionSetting() {
      return {
        step: 0.1, // 数值越大速度滚动越快
        // limitMoveNum: 8, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 30, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 50, // 单步运动停止的时间(默认值1000ms)
      };
    },

    dateSearch() {
      if (this.dateType == 'year') {
        return { startDate: this.searchParams.startYear + "-01", endDate: this.searchParams.endYear + "-01" }
      } else {
        return { startDate: this.dateRange[0], endDate: this.dateRange[1] }
      }
    }

  },
  methods: {
    pushRouter(src) {
      this.$router.push(src)
    },
    changeDateType() {
      this.getStatistics();
    },
    changeLastDay() {
      this.getWarnings();
    },
    //获取统计
    getStatistics() {

      const url = this.$api.cockpit.getStatistics;
      let params = {
        ...this.dateSearch,
        dateType: this.dateType
      }
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {

          this.statisticsData = res.data.data;

          this.drawDwdChart()

        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getWarnings() {
      const url = this.$api.cockpit.getWarnings;
      let params = {
        lastDay: this.lastDay
      }
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {

          this.warningsData = res.data.data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    drawDwdChart() {
      const data = this.statisticsData;
      let option = {
        // title: {
        //   text: '危废数据'
        // },
        grid: {
          left: '0',
          botttom: '0',
          containLabel: true
        },
        graphic: {
          type: 'text',     // 类型：文本
          left: 'center',
          top: 'middle',
          silent: true,     // 不响应事件
          invisible: data.length > 0,   // 有数据就隐藏
          style: {
            fill: '#9d9d9d',
            fontWeight: 'bold',
            text: '暂无数据',
            fontFamily: 'Microsoft YaHei',
            fontSize: '25px'
          }
        },
        legend: {
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
        },
        dataset: {
          dimensions: [
            'date', '产生量', "处置量", "贮存量"
          ],
          source: data
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            show: true,
            rotate: 40,
            textStyle: {
              color: '#fff' // 修改x轴标签颜色
            }
          },

        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#fff' // 修改y轴标签颜色
            },
            formatter: '{value} 吨'
          },

        },
        series: [{
          type: "bar",
          smooth: true,
          barMaxWidth: 20,
        }, {
          type: "bar",
          barMaxWidth: 20,
          smooth: true,
        }, {
          type: "bar",
          barMaxWidth: 20,
          smooth: true,
        }]
      };
      const myChart = echarts.init(document.getElementById("dw-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

  },
  mounted() {
    const thisYear = new Date().getFullYear();

    this.searchParams.startYear = thisYear - 1 + "";
    this.searchParams.endYear = thisYear + "";
    const m1 = this.$dayjs().subtract(6, 'month').format('YYYY-MM')
    const m2 = this.$dayjs().format('YYYY-MM')
    this.dateRange = [m1, m2];
    this.getStatistics();
    this.getWarnings();

  }
}
</script>

<style lang="scss" scoped>
.left-content {
  width: 100%;
  height: 100%;

  padding-left: 10px;

  .left-top {
    width: 100%;
    height: calc(50% - 10px);
    margin-bottom: 20px;
    border: 2px solid #1B4498;
    border-radius: 8px;
    padding: 0px 10px;

    .header {
      margin-bottom: 10px;
      margin-top: 5px;

      .title {
        font-size: 18px;
        cursor: pointer;
      }

      .tags {
        display: flex;
        width: 100%;
      }
    }

    .chart-main {
      width: 100%;
      height: calc(100% - 70px);
    }
  }



  .left-bottom {
    width: 100%;
    height: calc(50% - 10px);
    margin-bottom: 20px;
    border: 2px solid #1B4498;
    border-radius: 8px;

    padding: 0px 10px;

    .header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      margin-top: 5px;

      .title {
        font-size: 18px;
        cursor: pointer;
      }

      .tags {}
    }

    .warning-table {
      height: calc(100% - 100px);
    }

    .seamless-warp {
      height: calc(100% - 20px);
      overflow: hidden;
    }

    .warnings-table-no {
      width: 40px;
    }

    .warnings-table-name {
      width: 80px;
    }

    .warnings-table-status {
      width: 50px;
    }

    .warnings-table-content {
      flex: 1;
    }

    .list-title {
      margin-bottom: 10px;

      li {
        display: flex;
      }
    }

    .main-list {
      display: flex;
      padding: 6px 0px;

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 5px;

      }

    }
  }
}
</style>